<template>
  <div>
    <div class="flex">
      <div class="w-1/6 text-center bg-blue-100 rounded-lg border border-blue-400 mx-6 p-4">
        <h2 class="font-semibold text-xl">
          {{ usedQuota | numeral('0,0') }}
        </h2>
        <div class="text-xs">
          API calls used this month
          <div class="text-blue-400">
            (updated every minute)
          </div>
        </div>
      </div>
      <div class="w-5/6 h-16">
        API Calls used
        <div class="w-full h-8 bg-gray-200 text-blue-400 flex">
          <div
            class="h-full bg-blue-400"
            :style="{ width: usedQuotaPercentage + '%' }"
          />
          <div class="p-1 ml-1 font-light text-sm leading-6">
            <span class="font-bold">{{ usedQuota }}</span>/{{ quota }}
          </div>
        </div>
        <div class="flex justify-between">
          <span>0</span>
          <span>{{ quota }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotaUsage',
  props: {
    startDate: { type: Date, default: () => new Date() },
    endDate: { type: Date, default: () => new Date() },
    usedQuota: { type: Number, default: null },
    quota: { type: Number, default: null }
  },
  data () {
    return {
      filterDays: 30
    }
  },
  computed: {
    usedQuotaPercentage () {
      return this.usedQuota * 100 / this.quota
    }
  }
}
</script>
